import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ASSIGN_SPEAKERS } from '@shoflo/polymer/constants/ModalTypes';
import { AssignSpeakers as AssignSpeakersForm } from '@shoflo/polymer/components/AssignSpeakers/AssignSpeakers';
import { Modal, ModalBody } from 'reactstrap';
import {
  getSpeakerSourcesFromRoles,
  getHostSourcesFromRoles
} from '@shoflo/studio-redux/utils/broadcastRolesHelper';
import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';
import updateSource from 'actions/Broadcast/sources/updateSource';
import { getSpeakerSources, getHostSources } from './utils';
import { StudioLogger } from '@studio/logger/StudioLogger';
import { reduceSourceForLogs } from '@studio/sources/reduceSourceForLogs';

const logger = new StudioLogger('presentation-control');

function AssignSpeakers() {
  const dispatch = useDispatch();
  const clear = () => dispatch(clearModal(ASSIGN_SPEAKERS));
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === ASSIGN_SPEAKERS
  );
  const pdfSource = useSelector(({ modal }) => modal && modal.initialValue);
  const broadcastRoles = useSelector(state => state.broadcastRoles);
  const sources = useSelector(state => state.broadcastSources.sources);

  const speakerSources = getSpeakerSources(sources);
  const hostSources = getHostSources(sources);

  const broadcastSpeakers = getSpeakerSourcesFromRoles(
    broadcastRoles,
    speakerSources
  );
  const broadcastHosts = getHostSourcesFromRoles(broadcastRoles, hostSources);

  useEffect(() => {
    const hostSourcesData = reduceSourceForLogs(broadcastHosts);
    const speakerSourcesData = reduceSourceForLogs(broadcastSpeakers);
    const presentation = {
      hostSourcesData,
      speakerSourcesData,
      source: pdfSource
    };
    if (isOpen) {
      logger.info(
        'Presentation Control - Host - Assign speakers modal opened',
        { presentation }
      );
    }
  }, [isOpen, broadcastHosts, broadcastSpeakers]);

  if (!isOpen) return null;

  if (!pdfSource) {
    return null;
  }

  const previouslySelectedSpeakers = pdfSource.value?.speakerUserIds ?? [];

  function onSave(selectedSpeakerIds) {
    const { value, _id: id } = pdfSource;
    value.speakerUserIds = selectedSpeakerIds;
    dispatch(updateSource(id, { value }, { showPdfNotification: true }));
    const assignedUsersSource = selectedSpeakerIds.map(source =>
      sources.find(s => s.user === source)
    );
    const presentation = {
      source: pdfSource,
      assignedUsersSource,
      selectedSpeakerIds
    };
    logger.info(
      'Presentation Control - Host - Speaker assigned to presentation',
      { presentation }
    );
    clear();
  }

  return (
    <Modal isOpen={isOpen} toggle={clear}>
      <ModalBody className="p-4">
        <AssignSpeakersForm
          hostSources={broadcastHosts}
          speakerSources={broadcastSpeakers}
          onSave={onSave}
          onCancel={clear}
          previouslySelectedSpeakers={previouslySelectedSpeakers}
        />
      </ModalBody>
    </Modal>
  );
}

export default AssignSpeakers;
